import { render, staticRenderFns } from "./ChiefComplains.vue?vue&type=template&id=1421f47c&"
import script from "./ChiefComplains.vue?vue&type=script&lang=js&"
export * from "./ChiefComplains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports